<h1 *ngIf="!visibility">{{ error }}</h1>
<div class="row" *ngIf="visibility">
  <div class="column">
    <div >
      <div class="form-group col-md-6">
        <label for="documentNumber">Dosya No</label>
        <input
          type="text"
          class="form-control"
          id="documentNumber"
          [(ngModel)]="documentNumber"
          (ngModelChange)="documentNumber = $event.toLowerCase()"
        />

      </div>

      <div class="form-group col-md-6">
        <label for="inventionName">Buluş adı</label>
        <input
          type="text"
          class="form-control"
          id="inventionName"
          [(ngModel)]="inventionName"
          (ngModelChange)="inventionName = $event.toLowerCase()"
        />

      </div>

      <div class="form-group col-md-6">
        <label for="inventionDate">Buluş bildirim tarihi</label>
        <input
          type="date"
          class="icon"
          class="form-control"
          id="inventionDate"
          [(ngModel)]="inventionDate"
          placeholder="Buluş bildirim tarihi (gg/aa/YYYY Ex: 24/09/2018)"
        />

      </div>

      <br />
      <button type="button" class="btn" (click)="findInventor()">
        Buluş Sahibi Ekle
      </button>
      <button
        onmouseover="this.style.backgroundColor='#d70040';this.style.color='#f8f9fb'"
        onmouseleave="this.style.color='#d70040';this.style.backgroundColor='#f8f9fb'; "
        class="btn"
        type="button"
        id="add"
        style="background-color: #f8f9fb; color: #d70040"
        (click)="deleteInventors()"
      >
        Buluş Sahibi Listesini Temizle
      </button>
      <br />
      <br />
      <div>
        <button type="button" class="btn" (click)="findCompany()">
          Başvuru Sahibi Ekle
        </button>
        <button
          onmouseover="this.style.backgroundColor='#d70040';this.style.color='#f8f9fb'"
          onmouseleave="this.style.color='#d70040';this.style.backgroundColor='#f8f9fb'; "
          type="button"
          id="add"
          class="btn"
          style="background-color: #f8f9fb; color: #d70040"
          (click)="deleteCompanys()"
        >
          Başvuru Sahibi Listesini Temizle
        </button>
      </div>
      <br />

      <div>
        <button type="button" class="btn" (click)="findAttorney()">
          Vekil Bilgisi Ekle
        </button>
        <button
          onmouseover="this.style.backgroundColor='#d70040';this.style.color='#f8f9fb'"
          onmouseleave="this.style.color='#d70040';this.style.backgroundColor='#f8f9fb'; "
          type="button"
          id="add"
          class="btn"
          style="background-color: #f8f9fb; color: #d70040"
          (click)="deleteAttornies()"
        >
          Vekil Listesini Temizle
        </button>
      </div>
      <br />
      <div>
        <button type="button" class="btn" (click)="findProjects()">
         Proje Ekle
        </button>
        <button
          onmouseover="this.style.backgroundColor='#d70040';this.style.color='#f8f9fb'"
          onmouseleave="this.style.color='#d70040';this.style.backgroundColor='#f8f9fb'; "
          type="button"
          id="add"
          class="btn"
          style="background-color: #f8f9fb; color: #d70040"
          (click)="deleteProjects()"
        >
          Proje Listesini Temizle
        </button>
      </div>
      <br />
      <div>
        <button type="button" class="btn" (click)="findRDCenters()">
          Ar-Ge merkezi Ekle
        </button>
        <button
          onmouseover="this.style.backgroundColor='#d70040';this.style.color='#f8f9fb'"
          onmouseleave="this.style.color='#d70040';this.style.backgroundColor='#f8f9fb'; "
          type="button"
          id="add"
          class="btn"
          style="background-color: #f8f9fb; color: #d70040"
          (click)="deleteRDCenters()"
        >
          Ar-Ge Merkezi Listesini Temizle
        </button>
      </div>
      <br />
      <label for="inventors">Buluş sahipleri</label>

      <h2 *ngIf="record">{{ record }}</h2>

      <div>
        <table>
          <thead>
            <th>#</th>
            <th>Buluş Sahibinin Adı/Soyadı</th>
            <!-- <th>Buluş Sahibinin Adresi</th>
            <th>Buluş Sahibinin e-postası</th>
            <th>Buluş Sahibi Kimlik No</th>
            <th>Buluş Sahibi Türü</th> -->
          </thead>
          <tbody>
            <tr *ngFor="let user of inventor; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ user.name }}</td>
              <!-- <td>{{ user.adress }}</td>
              <td>{{ user.mail }}</td>
              <td>{{ user.identity }}</td>
              <td>{{ user.status }}</td> -->

              <button
                type="button"
                id="add"
                class="btn btn-primary"
                (click)="findInventor()"
                style="background-color: #28384f"
              >
                Daha fazla Buluş Sahibi ekle
              </button>
            </tr>
          </tbody>
        </table>
      </div>
      <label for="inventors">Başvuru Sahipleri</label>

      <h2 *ngIf="record">{{ record }}</h2>

      <div class="form-group col-md-12">
        <table>
          <thead>
            <th>#</th>
            <th>Başvuru Sahibinin Adı</th>
            <!-- <th>Başvuru Sahibi Adresi</th>
            <th>Başvuru Sahibi Kurum No</th> -->
          </thead>
          <tbody>
            <tr *ngFor="let user of company; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ user.name }}</td>
              <!-- <td>{{ user.adress }}</td>
              <td>{{ user.identity }}</td> -->

              <button
                type="button"
                id="add"
                class="btn btn-primary"
                (click)="findCompany()"
                style="background-color: #28384f"
              >
                Daha çok Başvuru Sahibi ekle
              </button>
            </tr>
          </tbody>
        </table>
      </div>
      <div></div>
      <label for="inventors">Vekil bilgileri</label>

      <h2 *ngIf="record">{{ record }}</h2>

      <div class="form-group col-md-12">
        <table>
          <thead>
            <th>#</th>
            <th>Vekilin Adı</th>
            <!-- <th>Başvuru Sahibi Adresi</th>
            <th>Başvuru Sahibi Kurum No</th> -->
          </thead>
          <tbody>
            <tr *ngFor="let user of attorney; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ user.name }}</td>
              <!-- <td>{{ user.adress }}</td>
              <td>{{ user.identity }}</td> -->

              <button
                type="button"
                id="add"
                class="btn btn-primary"
                (click)="findAttorney()"
                style="background-color: #28384f"
              >
                Daha çok Vekil Kaydı ekle
              </button>
            </tr>
          </tbody>
        </table>
      </div>
      <label for="inventors">Ar-Ge Merkezleri</label>

      <h2 *ngIf="record">{{ record }}</h2>

      <div>
        <table>
          <thead>
            <th>#</th>
            <th>Ar-Ge Merkezinin Adı/Soyadı</th>

          </thead>
          <tbody>
            <tr *ngFor="let user of rdCenter; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ user.centerName }}</td>


              <button
                type="button"
                id="add"
                class="btn btn-primary"
                (click)="findRDCenters()"
                style="background-color: #28384f"
              >
                Daha fazla Ar-Ge Merkezi ekle
              </button>
            </tr>
          </tbody>
        </table>
      </div>
      <label for="inventors">İlgili Projeler</label>

      <h2 *ngIf="record">{{ record }}</h2>

      <div>
        <table>
          <thead>
            <th>#</th>
            <th>Proje Kodu</th>
            <th>Proje Bilgisi</th>
          </thead>
          <tbody>
            <tr *ngFor="let user of project; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ user.projectCode }}</td>
              <td>{{ user.projectDetail }}</td>

              <button
                type="button"
                id="add"
                class="btn btn-primary"
                (click)="findProjects()"
                style="background-color: #28384f"
              >
                Daha fazla Proje ekle
              </button>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      <p *ngIf="!inventorAdded" style="color: red; font-style: italic">
        *En az 1 Buluş Sahibi giriniz
      </p>
      <p *ngIf="!CompanyAdded" style="color: red; font-style: italic">
        *En az 1 Başvuru Sahibi giriniz
      </p>

      <ng-container *ngIf="inventorAdded && CompanyAdded">
        <button
          (click)="submit()"
          class="btn"

          style="
            margin-left: auto;
            margin-right: 1%;
            font-size: 18px;
            display: block;
            background-color: #d70040;
          "
        >
          Taslak Buluşu Kaydet
        </button>
      </ng-container>
    </div>
  </div>
  <div class="column">
    <h2 *ngIf="visibleInventor && !error">Sisteme kayıtlı Buluş Sahipleri</h2>
    <h2 *ngIf="error">{{ error }}</h2>
    <input
      *ngIf="visibleInventor && !error"
      class="form-control"
      class="icon"
      type="text"
      name="search"
      [(ngModel)]="searchText"
      autocomplete="off"
      placeholder="Buluş Sahibi bilgileri üzerinden ara"
      id="input1"
    />
    <p></p>

    <table *ngIf="visibleInventor" style="table-layout: fixed; width: 100%">
      <thead>
        <th style="word-wrap: break-word">#</th>
        <th style="word-wrap: break-word">Buluş Sahibinin Adı/Soyadı</th>
        <!-- <th style="width: 20%; word-wrap: break-word">Buluş Sahibinin Adresi</th>
        <th style="width: 15%; word-wrap: break-word">Buluş Sahibinin e-postası</th>
        <th style="width: 15%; word-wrap: break-word">Buluş Sahibi Kimlik No</th>
        <th style="width: 15%; word-wrap: break-word">Buluş Sahibi Türü</th> -->
        <th style="word-wrap: break-word"></th>
      </thead>
      <tbody>
        <tr *ngFor="let user of users; let i = index">
          <ng-container *ngFor="let item of user | filter: searchText">
            <td style="word-wrap: break-word">{{ i + 1 }}</td>
            <td style="word-wrap: break-word">
              {{ item.inventorName }}
            </td>
            <td style="word-wrap: break-word">
              <button
                type="button"
                id="add"
                class="btn btn-primary"
                (click)="getInventor(i)"
                style="word-wrap: break-word"
              >
                Buluş Sahibini Ekle
              </button>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
    <h2 *ngIf="visibleCompany && !error">Sisteme kayıtlı Başvuru Sahipleri</h2>
    <h2 *ngIf="error">{{ error }}</h2>
    <input
      *ngIf="visibleCompany && !error"
      class="form-control"
      class="icon"
      type="text"
      name="search"
      [(ngModel)]="searchText"
      autocomplete="off"
      placeholder="Başvuru Sahibi bilgileri üzerinden ara"
      id="input1"
    />
    <table *ngIf="visibleCompany" style="table-layout: fixed; width: 100%">
      <thead>
        <th style="width: 4%; word-wrap: break-word">#</th>
        <th style="width: 73%; word-wrap: break-word">Başvuru Sahibi Adı</th>
        <!-- <th style="width: 25%; word-wrap: break-word">Başvuru Sahibi Adresi</th>
        <th style="width: 25%; word-wrap: break-word">Başvuru Sahibi Kurum No</th> -->
        <th style="width: 23%; word-wrap: break-word"></th>
      </thead>
      <tbody>
        <tr *ngFor="let user of companies; let i = index">
          <ng-container *ngFor="let item of user | filter: searchText">
            <td style="width: 4%; word-wrap: break-word">{{ i + 1 }}</td>
            <td style="width: 90%; word-wrap: break-word">
              {{ item.CompanyName }}
            </td>
            <!-- <td style="width: 25%; word-wrap: break-word">
              {{ item.CompanyAdress }}
            </td>
            <td style="width: 25%; word-wrap: break-word">
              {{ item.CompanyIdentityNo }}
            </td> -->
            <td style="width: 6%; word-wrap: break-word">
              <button
                type="button"
                id="add"
                class="btn btn-primary"
                (click)="getCompany(i)"
              >
                Başvuru Sahibi ekle
              </button>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>

    <h2 *ngIf="visibleAttorney && !error">Sisteme kayıtlı Vekiller</h2>
    <h2 *ngIf="error">{{ error }}</h2>
    <input
      *ngIf="visibleAttorney && !error"
      class="form-control"
      class="icon"
      type="text"
      name="search"
      [(ngModel)]="searchText"
      autocomplete="off"
      placeholder="Vekil bilgileri üzerinden ara"
      id="input1"
    />
    <table *ngIf="visibleAttorney" style="table-layout: fixed; width: 100%">
      <thead>
        <th style="width: 4%; word-wrap: break-word">#</th>
        <th style="width: 73%; word-wrap: break-word">Vekil Adı</th>
        <!-- <th style="width: 25%; word-wrap: break-word">Başvuru Sahibi Adresi</th>
        <th style="width: 25%; word-wrap: break-word">Başvuru Sahibi Kurum No</th> -->
        <th style="width: 23%; word-wrap: break-word"></th>
      </thead>
      <tbody>
        <tr *ngFor="let user of attornies; let i = index">
          <ng-container *ngFor="let item of user | filter: searchText">
            <td style="width: 4%; word-wrap: break-word">{{ i + 1 }}</td>
            <td style="width: 90%; word-wrap: break-word">
              {{ item.AttorneyName }}
            </td>
            <!-- <td style="width: 25%; word-wrap: break-word">
              {{ item.CompanyAdress }}
            </td>
            <td style="width: 25%; word-wrap: break-word">
              {{ item.CompanyIdentityNo }}
            </td> -->
            <td style="width: 6%; word-wrap: break-word">
              <button
                type="button"
                id="add"
                class="btn btn-primary"
                (click)="getAttorney(i)"
              >
                Vekil ekle
              </button>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
    <h2 *ngIf="visibleRDCenter && !error">Sisteme kayıtlı Ar-Ge Merkezleri</h2>
    <h2 *ngIf="error">{{ error }}</h2>
    <input
      *ngIf="visibleRDCenter && !error"
      class="form-control"
      class="icon"
      type="text"
      name="search"
      [(ngModel)]="searchText"
      autocomplete="off"
      placeholder="Ar-Ge Merkezleri üzerinden ara"
      id="input1"
    />
    <table *ngIf="visibleRDCenter" style="table-layout: fixed; width: 100%">
      <thead>
        <th style="width: 4%; word-wrap: break-word">#</th>
        <th style="width: 73%; word-wrap: break-word">Ar-Ge Merkezinin Adı</th>

        <th style="width: 23%; word-wrap: break-word"></th>
      </thead>
      <tbody>
        <tr *ngFor="let user of rdCenters; let i = index">
          <ng-container *ngFor="let item of user | filter: searchText">
            <td style="width: 4%; word-wrap: break-word">{{ i + 1 }}</td>
            <td style="width: 90%; word-wrap: break-word">
              {{ item.centerName }}
            </td>

            <td style="width: 6%; word-wrap: break-word">
              <button
                type="button"
                id="add"
                class="btn btn-primary"
                (click)="getRDCenters(i)"
              >
                Ar-Ge Merkezi Ekle
              </button>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
    <h2 *ngIf="visibleProjects && !error">Sisteme kayıtlı Projeler</h2>
    <h2 *ngIf="error">{{ error }}</h2>
    <input
      *ngIf="visibleProjects && !error"
      class="form-control"
      class="icon"
      type="text"
      name="search"
      [(ngModel)]="searchText"
      autocomplete="off"
      placeholder="Projeler üzerinden ara"
      id="input1"
    />
    <table *ngIf="visibleProjects" style="table-layout: fixed; width: 100%">
      <thead>
        <th style="width: 4%; word-wrap: break-word">#</th>
        <th style="width: 73%; word-wrap: break-word">Proje Kodu</th>
        <th style="width: 73%; word-wrap: break-word">Proje Detayı</th>

        <th style="width: 23%; word-wrap: break-word"></th>
      </thead>
      <tbody>
        <tr *ngFor="let user of projects; let i = index">
          <ng-container *ngFor="let item of user | filter: searchText">
            <td style="width: 4%; word-wrap: break-word">{{ i + 1 }}</td>
            <td style="width: 90%; word-wrap: break-word">
              {{ item.projectCode }}
            </td>
            <td style="width: 90%; word-wrap: break-word">
              {{ item.projectDetail }}
            </td>

            <td style="width: 6%; word-wrap: break-word">
              <button
                type="button"
                id="add"
                class="btn btn-primary"
                (click)="getProjects(i)"
              >
                Proje ekle
              </button>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </div>
</div>
